import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApiService } from '~app/services/api.service';
import { AuthService } from '~app/services/auth.service';

interface DevPersona {
  key: string;
  label: string;
  email: string;
  firstName: string;
  lastName: string;
}

@Component({
  selector: 'ciao-dev-user-switcher',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './dev-user-switcher.component.html',
  styleUrls: ['./dev-user-switcher.component.less'],
})
export class DevUserSwitcherComponent implements OnInit {
  personas: DevPersona[] = [];
  activePersona = '';
  switching = false;

  constructor(
    private apiService: ApiService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.apiService
      .GetSingle<{ personas: DevPersona[]; activePersona: string }>(
        '/auth/dev-personas'
      )
      .subscribe({
        next: (data) => {
          this.personas = data.personas;
          this.activePersona = data.activePersona;
        },
        error: () => {
          // Not in dev mode or endpoint unavailable — hide the switcher
          this.personas = [];
        },
      });
  }

  onSwitch(personaKey: string) {
    if (personaKey === this.activePersona || this.switching) return;
    this.switching = true;
    this.apiService
      .Post<{ switched: string }>('/auth/dev-switch-user', {
        persona: personaKey,
      })
      .subscribe({
        next: () => {
          this.activePersona = personaKey;
          this.switching = false;
          // Reload the current user to pick up the new persona
          this.authService.loadCurrentUser();
          // For the non-registered persona we wiped the DB record server-side,
          // so route straight to /register; for everyone else, full reload so
          // all services re-fetch scoped data.
          setTimeout(() => {
            if (personaKey === 'non_registered') {
              window.location.assign('/register');
            } else {
              window.location.reload();
            }
          }, 300);
        },
        error: (err) => {
          console.error('Failed to switch persona:', err);
          this.switching = false;
        },
      });
  }
}
